// removed by extract-text-webpack-plugin
module.exports = {"planItem":"_3TOte","inactive":"_3uhUX","headerPill":"_1TdYZ","headerPillIcon":"_3CZAI","planTitle":"_3xhK5","planHeader":"_3cPIO","content":"_3r4CW","features":"_2FFjg","rate":"_3CAA4","wasPrice":"_3A3Q_","strikethrough":"_1y2Tt","pricing":"rRNco","price":"_3DwQq","interval":"_3TDYg","limit":"H5xru","highlightedFeature":"gIRwB","disclaimer":"_2x6hy","genericButton":"HIDJI","terms":"_187x7"};


//////////////////
// WEBPACK FOOTER
// ./components/PlanItem/styles.scss
// module id = 289
// module chunks = 0